























































import Vue from 'vue'
import { PropType } from '@vue/composition-api'
import SocialStreamConfigStore from '@/store/socialStream/socialStreamConfig'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'
import DefaultProductsStore from '@/store/socialStream/socialStreamDefaultProducts'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import ProductsByRowList from '@/views/components/socialStream/ProductsByRowList.vue'
import PostListManage from '@/views/components/socialStream/PostListManage.vue'
import DefaultProductsList from '@/views/components/socialStream/DefaultProductsList.vue'
import { LinkIcon } from 'vue-feather-icons'

export default Vue.extend({
  components: {
    PostListManage, ProductsByRowList, DefaultProductsList, LinkIcon
  },
  data() {
    return {
      catalogId: 'not-set',
      sort: {
        field: 'id',
        order: 'asc',
      },
      query: '',
      productsListOpen: false,
    }
  },
  computed: {
    config() {
      return SocialStreamConfigStore.state.data.socialStreamConfig
    },
    catalogs() {
      return SocialStreamConfigStore.state.data.socialStreamCatalogs
    },
    dataLoading() {
      return SocialStreamConfigStore.state.dataLoading
    },
    defaultProductsLoading() {
      return DefaultProductsStore.state.dataLoading
    },  
    productsListTitle() {
      return this.$t('socialStream.productList.title')
    },
    defaultProductsCnt() {
      return DefaultProductsStore.state.linkedIds.length
    },
  },
  watch: {
    dataLoading() {  
        this.setProductsFromCatalogStore()
        this.setDefaultProductsStore()
    },
  },
  mounted() {
    this.getData()
    if(!SocialStreamConfigStore.state.dataLoading){
        this.setProductsFromCatalogStore()
        this.setDefaultProductsStore()
    }
  },
  methods: {
    setProductsFromCatalogStore() {
      ProductsFromCatalogStore.commit('setSortByDirection', 'desc')
      ProductsFromCatalogStore.commit('setCatalogId', SocialStreamConfigStore.state.data.socialStreamCatalogs.productsCatalogId)
    },
    getData() {
      SocialStreamConfigStore.dispatch('getSocialStreamConfig', this.$route.params.configId)      
    },
    setDefaultProductsStore() {
      DefaultProductsStore.commit('setInstanceId', this.$route.params.configId)
      DefaultProductsStore.commit('setCatalogId', SocialStreamConfigStore.state.data.socialStreamCatalogs.productsCatalogId)
      DefaultProductsStore.dispatch('getDefaultProducts')
    },
    hasProductsToDisplay() {
      return ProductsFromCatalogStore.state.productsList !== null
    },
    productsToDisplay() {
      return ProductsFromCatalogStore.state.productsList as Array<CatalogItem>
    },
    hasDefaultProducts() {
      return DefaultProductsStore.state.linkedIds.length > 0
    },
    defaultProducts() {
      return Object.values(DefaultProductsStore.state.linkedProducts)
    },    
    linkItem(product: CatalogItem) {
      DefaultProductsStore.dispatch('addDefaultProduct', product)
    },
    detachItem(itemId: string) {
      DefaultProductsStore.dispatch('removeDefaultProduct', itemId)
    },
    linkedProductsIds() {
      return Array.isArray(DefaultProductsStore.state.linkedIds) ? DefaultProductsStore.state.linkedIds : []
    },    
  },
})
